import { defineAsyncComponent } from "vue";
import HtmlBlock from "./html-block.vue";
import VideoBlock from "./video-block.vue";
import CallToAction from "./call-to-action.vue";
import CardsCallToAction from "./cards-cta.vue";
import DemoProductList from "./demo-product-list.vue";
import FAQ from "./faq.vue";
import Features from "./features.vue";
import CallToActionWithImage from "./heras-call-to-action-with-image.vue";
import HeroHeader from "./hero-header.vue";
import ImageBlock from "./image-block.vue";
import Newsletter from "./newsletter.vue";
import ProductDetailCarousel from "./product-detail-carousel.vue";
import ProductInfo from "./product-info.vue";
import PromoText from "./promo-text.vue";
import RelatedProducts from "./related-products.vue";
import SubscribeForm from "./subscribe-form.vue";
import TextBlock from "./text-block.vue";
import TextImageLarge from "./text-image-large.vue";
import TitleBlock from "./title-block.vue";
import type { Component } from "vue";

const Slider = defineAsyncComponent(() => import("./slider.vue"));

// Innovadis custom. The registration of the components for the page builder is now in client-app/plugins/builder-preview/register-components.ts

export const templateBlocks: { [key: string]: Component } = {
  "call-to-action-with-image": CallToActionWithImage,
  "text-image-large": TextImageLarge,
  "call-to-action": CallToAction,
  "cards-call-to-action": CardsCallToAction,
  "subscribe-form": SubscribeForm,
  "related-products": RelatedProducts,
  "product-detail-carousel": ProductDetailCarousel,
  "title-block": TitleBlock,
  faq: FAQ,
  newsletter: Newsletter,
  "hero-header": HeroHeader,
  "demo-product-list": DemoProductList,
  features: Features,
  "image-block": ImageBlock,
  "product-info": ProductInfo,
  "video-block": VideoBlock,
  "promo-text": PromoText,
  slider: Slider,
  "text-block": TextBlock,
  "html-block": HtmlBlock,
};
